<template>
  <el-dialog title="客服订单审核流程" :visible.sync="visibleDialog" width="520px" top="calc(50vh - 220px)" class="pop-dialog pop-audit-record" append-to-body>
    <step-progress :orderObj="row" :processFunc="dictionaries.process_func" type="shenheStep" class="con"></step-progress>
  </el-dialog>
</template>
<script>
import StepProgress from '@/components/StepProgress'
export default {
  name: 'popAuditRecord',
  components: {
    StepProgress,
  },
  data() {
    return {
      visibleDialog: false,
      loading: false,
      row:  { },
      stepProgress: [],
      dictionaries: { // 字典数据
        process_func: [],
      }
    }
  },
   created(){
      for (const type in this.dictionaries) { this.getDictionaries(type) }
    },
  methods: {
    // 批量设置不需要回显
    show(item) {
      this.row = item
      this.id = item.id
      this.page = 1
      this.total = 0
      this.tableData = []
      console.log('show:', item)
      this.visibleDialog = true
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) { return }
        const params = { groupId: type }
        this.$api.dictionaries(params).then((res) => {
          this.dictionaries[type] = res.data
        }).catch((err) => {
          console.log(err)
        })
      },
   
  },
}
</script>
<style lang='scss'>
.pop-audit-record {
  
  .con{
    padding-top: 30px;
    min-height: 100px;
  }
}
</style>